var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { createAuthenticationSession, getConfiguration, getTokenAgainstStatement, registerCurrentDevice } from '../Apis';
import { publishInitiateTvePopup } from './tve-login-events';
import "./style.scss";
import Cookies from 'js-cookie';
import { SocialSpinner } from '../../HomeLoadingScreen/Spinner';
import { backIcon, tveSearchIcon, whiteCloseIcon } from '../../../../images/icon';
import { publishAppLoading } from '../../../OnBoarding-V2/Events/utils.events';
var V2TveDialogPopup = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var _k = __read(useState(true), 2), providerLoader = _k[0], setProviderLoader = _k[1];
    var featuredProvider = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsPlatform) === null || _b === void 0 ? void 0 : _b.tveSettings) === null || _c === void 0 ? void 0 : _c.providers;
    var _l = __read(useState([]), 2), mvpd = _l[0], setMvpd = _l[1];
    var _m = __read(useState([]), 2), mvpdFullList = _m[0], setMvpdFullList = _m[1];
    var desktopLogo = (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.app_data) === null || _d === void 0 ? void 0 : _d.appcmsPlatform) === null || _e === void 0 ? void 0 : _e.images) === null || _f === void 0 ? void 0 : _f.desktopLogo;
    var adobeVersion = ((_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.app_data) === null || _g === void 0 ? void 0 : _g.appcmsPlatform) === null || _h === void 0 ? void 0 : _h.tveSettings) === null || _j === void 0 ? void 0 : _j.version) || "v1";
    var _o = __read(useState(null), 2), searchKeyword = _o[0], setSearchKeyword = _o[1];
    var _p = __read(useState(false), 2), toggleFullList = _p[0], settoggleFullList = _p[1];
    var checkValidMvpd = function (mvpdprovider) {
        for (var i = 0; i < mvpd.length; i++) {
            if (mvpdprovider.identifier == mvpd[i].ID || mvpdprovider.identifier == mvpd[i].id) {
                return true;
            }
        }
        return false;
    };
    var initiateTveLogin = function () {
        if (typeof window !== 'undefined') {
            registerCurrentDevice().then(function (res) {
                getTokenAgainstStatement(__assign({}, res.data)).then(function () {
                    getConfiguration().then(function (res) {
                        setMvpd(res);
                        setMvpdFullList(res);
                        setProviderLoader(false);
                    });
                });
            });
        }
    };
    useEffect(function () {
        var getTveAccessToken = Cookies.get('TveAccessToken');
        var getFingerprintDeviceId = localStorage.getItem('fingerprintDeviceId');
        adobeVersion == "v2" && ((!getTveAccessToken || !getFingerprintDeviceId) ? initiateTveLogin() : getConfiguration().then(function (res) {
            setMvpd(res);
            setMvpdFullList(res);
            setProviderLoader(false);
        }));
    }, []);
    var searchDebounce;
    var filterMvpdList = function (e) {
        var _a, _b;
        clearTimeout(searchDebounce);
        var searchVal = (_b = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase();
        if (searchVal === "") {
            setMvpd(mvpdFullList);
            setSearchKeyword(null);
            return;
        }
        setSearchKeyword(searchVal);
        searchDebounce = setTimeout(function () {
            var filteredList = mvpdFullList.filter(function (provider) { return provider.displayName.toLowerCase().includes(searchVal); });
            setMvpd(filteredList);
        }, 300);
    };
    var onClose = function () {
        publishInitiateTvePopup(false);
    };
    var setSelectedprovider = function (mvpdId) {
        var _a, _b;
        var domainName = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.host;
        if (domainName.includes("www.")) {
            domainName = domainName.replace("www.", "");
        }
        var data = new URLSearchParams();
        data.append('mvpd', mvpdId);
        data.append('domainName', domainName);
        data.append('redirectUrl', "".concat((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.origin).concat(window.location.pathname, "?isTveUser=Authenticated"));
        localStorage.setItem('selectedMvpdId', mvpdId);
        createAuthenticationSession(data);
    };
    return (React.createElement("div", { className: "v2-login-popup-overlay" },
        React.createElement("div", { className: 'close-btn-wrapper' },
            React.createElement("button", { className: "close-button", onClick: function () {
                    setMvpd(mvpdFullList);
                    setSearchKeyword(null);
                    settoggleFullList(false);
                } },
                backIcon(),
                " back"),
            React.createElement("button", { className: "close-button", onClick: onClose }, whiteCloseIcon())),
        React.createElement("div", { className: "v2-tve-container site-background-color site-color", onClick: function (e) { return e.stopPropagation(); } },
            React.createElement("div", { className: "popup-content" },
                React.createElement("div", { className: "popup-left" },
                    React.createElement("div", { className: "logo-wrapper" },
                        React.createElement("img", { src: "https://spinco.staging.asset.viewlift.com/images/2025/04/29/image-17--1745926227094.png", alt: "Logo" }))),
                React.createElement("div", { className: "popup-right" },
                    React.createElement("div", { className: 'head' }, "Choose Your TV Provider"),
                    React.createElement("div", { className: 'subtitle' },
                        "Don't see your provider? Search below, or select from the ",
                        React.createElement("span", { onClick: function () { return settoggleFullList(!toggleFullList); } }, "full list"),
                        "."),
                    React.createElement("div", { className: "search-container" },
                        React.createElement("input", { type: "text", placeholder: "Search", className: "search-input", value: !searchKeyword ? "" : searchKeyword, onChange: filterMvpdList }),
                        React.createElement("span", { className: "search-icon" }, tveSearchIcon())),
                    !providerLoader ? React.createElement("div", null,
                        React.createElement("div", { className: "mvpd-grid" }, mvpd.length > 0 && !searchKeyword && !toggleFullList && featuredProvider.map(function (provider, index) {
                            var isValidMvpd = checkValidMvpd(provider);
                            if (isValidMvpd) {
                                return (React.createElement("div", { key: index, className: "grid-item", onClick: function () {
                                        publishAppLoading(true);
                                        setSelectedprovider(provider.identifier);
                                    } },
                                    React.createElement("img", { src: provider.logoUrl, alt: "grid-".concat(index, " ").concat(provider === null || provider === void 0 ? void 0 : provider.displayName) })));
                            }
                        })),
                        mvpd.length > 0 && (searchKeyword || toggleFullList) ? React.createElement("div", { className: 'list-container' },
                            React.createElement("ul", null, mvpd.map(function (provider, index) {
                                return (React.createElement("li", { key: index, className: "mvpd-provider", onClick: function () {
                                        publishAppLoading(true);
                                        setSelectedprovider(provider.id);
                                    } },
                                    React.createElement("p", null, provider === null || provider === void 0 ? void 0 : provider.displayName)));
                            }))) : null) : React.createElement(SocialSpinner, null))))));
};
export default V2TveDialogPopup;
